<a
    class="timer hu-light:text-white pn-light-dark:text-white"
    *ngIf="(timer$ | async) !== 900 && (status$ | async) !== 'Y'"
    [routerLink]="'/purchase/cart' | localize"
    attr.aria-label="{{ 'MINUTES_LEFT_ARIA_LABEL' | translate }} {{ timer$ | async | timeFromInt }}">
    {{ timer$ | async | timeFromInt }}
</a>
